import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getOneShippingInfo,
  createShippingInfo,
  updateShippingInfo,
  deleteShippingInfo,
  viewShippingInfoReport,
} from "services/shippinginfo";

export const useOneShippingInfo = (id, options = {}) => {
  return useQuery({
    queryKey: ["shipping-info", id],
    queryFn: () => getOneShippingInfo(id),
    enabled: !!id && (options.enabled !== false),
    ...options,
  });
};

export const useCreateShippingInfo = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => createShippingInfo(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["all-salebills"] });
      queryClient.invalidateQueries({ queryKey: ["shipping-info"] });
    },
  });
};

export const useUpdateShippingInfo = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, data }) => updateShippingInfo(id, data),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["all-salebills"] });
      queryClient.invalidateQueries({ queryKey: ["shipping-info"] });
      queryClient.invalidateQueries({ queryKey: ["shipping-info", variables.id] });
    },
  });
};

export const useDeleteShippingInfo = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (id) => deleteShippingInfo(id),
    onSuccess: (data, id) => {
      queryClient.invalidateQueries({ queryKey: ["all-salebills"] });
      queryClient.invalidateQueries({ queryKey: ["shipping-info"] });
      queryClient.invalidateQueries({ queryKey: ["shipping-info", id] });
    },
  });
};

export const useViewShippingInfoReport = () => {
  return useMutation({
    mutationFn: (id) => viewShippingInfoReport(id),
  });
};
